<template>
<!-- closeable
    close-icon="https://file.40017.cn/appresource/image/forStudent/new/icon_closed@2x.png"
-->
    <van-popup
        v-model="showPop"
        class="rule-popup-box">
        <img class="top-img" src="https://file.40017.cn/appresource/image/forStudent/new/img_close@2x.png" alt="">
        <div class="title-popup">{{title}}</div>
        <p class="desc">在APP内绑定微信，即可享受专属特权！</p>
        <div class="cont-box">
            <div class="item-box" v-for="(item, index) in rightsList" :key="index">
                <img class="img-box" :src="item.img" alt="">
                <p class="txt">{{item.title}}</p>
            </div>
        </div>
        <div class="btn-box" v-if="isShowBtn">
            <button class="btn" @click="goBindWx"> <img class="icon-box" src="https://file.40017.cn/appresource/image/forStudent/new/icon_wx@3x.png" alt=""> 绑定微信 解锁权益</button>
        </div>
    </van-popup>
</template>

<script>
import { Popup, Toast, Icon } from 'vant';

export default {
    name: 'rulePopup',
    props: {
        title: {
            type: String,
            default: '您的权益待解锁'
        },
        content: {
            type: String,
            default: ''
        },
        isShowBtn: {
            type: Boolean,
            default: false
        },
        loginInfo: {
            type: Object,
            default: () => {}
        },
    },
    components: {
        [Popup.name]: Popup,
        [Icon.name]: Icon
    },
    data() {
        return {
            showPop: false,
            rightsList: [{
                img: 'https://file.40017.cn/appresource/image/forStudent/new/icon-jhddfx@3x.png',
                title: '单单返现'
            },{
                img: 'https://file.40017.cn/appresource/image/forStudent/new/icon-qycxk@3x.png',
                title: '同程学生卡'
            },{
                img: 'https://file.40017.cn/appresource/image/forStudent/new/icon-jjhxsj@3x.png',
                title: '机酒火学生价'
            }]
        }
    },
    methods: {
        show() {
            this.showPop = true
        },
        goBindWx() {
            this.$emit('setTrack', {
                action: 'wechat_bind_click',
                label: '微信绑定弹窗点击',
                value:''
            })
            _tc_bridge_util.app_bind_wx({
                param: {
                    memberId: this.loginInfo.memberId,
                    mobile: this.loginInfo.mobile
                },
                callback: (data)=> {
                    let res = JSON.parse(data.CBData)
                    console.log("brige微信callback", res);
                    this.showPop = false
                    if (res && +res.status === 1) {
                        // 绑定成功后，重新查询首页数据
                        this.isBindWx = true
                        Toast("绑定成功",{duration: 1000})
                    } else {
                        Toast(res.msg || "绑定失败，请稍后再试",{duration: 1000})
                    }
                }
            })
        }
    }

}
</script>

<style lang="less" scoped>
.rule-popup-box {
    background: #FFFFFF url(//file.40017.cn/appresource/image/forStudent/new/bg_popup_top2@2x.png) no-repeat;
    background-size: contain;
    border-radius: 12px;
    overflow-y: visible;
    padding: 0 20px;
    ::v-deep .van-popup__close-icon {
        position: absolute;
        .van-icon__image {
            width: 24px;
            height: 24px;
        }
    }
    .top-img {
        // position: absolute;
        // top: -20px;
        // left: 50%;
        // margin-left: -82px;
        width: 163px;
        height: 110px;
        margin: -40px auto 0;
    }
    .title-popup {
        text-align: center;
        line-height: 28px;
        font-size: 20px;
        color: #333333;
        font-weight: 600;
        margin-top: -16px;
    }
    .desc {
        font-size: 14px;
        color: #888888;
        margin: 8px 0 20px;
        text-align: center;
    }
    .cont-box {
        width: 250px;
        display: flex;
        // justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        margin: 12px 4px 8px;
        color: #333333;
        font-size: 14px;
        line-height: 1.5;
        .item-box {
            width: 82px;
            text-align: center;
            margin-bottom: 12px;
            .img-box {
                display: inline-block;
                width: 44px;
                height: 44px;
                border-radius: 22px;
                vertical-align: text-top;
            }
            .txt {
                font-size: 11px;
                color: #333333;
                margin-top: 8px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis
            }
        }
    }
    .btn-box {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 0 0 20px;
        .btn {
            display: flex;
            justify-content: space-around;
            align-items: center;
            min-width: 216px;
            // flex: 1;
            font-weight: 600;
            font-size: 16px;
            color: #FFFFFF;
            // border: 1px solid #06C584;
            border-radius: 22px;
            padding: 11px 26px;
            margin: 0 4px;
            background-image: linear-gradient(90deg, #01E36D 0%, #06C584 100%);
            &.btn-empty {
                min-width: 108px;
                color: #06C584;
                border: 1px solid #06C584;
                background: #fff;
            }
            .icon-box {
                width: 22px;
                height: 22px;
                margin-right: 7px;
            }
        }
    }
}
</style>>
